export default __webpack_public_path__ + "static/media/about-banner.63f1bbdb.1d68103b.webp";